import { useState, useCallback } from 'react';
import orderService, { Order } from '../services/order';
import { message } from 'antd';

export interface SortConfig {
  field?: string;
  order?: 'ascend' | 'descend';
}

export function useOrders(
  deps: {
    searchText: string;
    searchField: string;
    serviceFilter?: string;
    subServiceFilter?: string;
    filters: Record<string, any>;
    pagination: { current: number; pageSize: number; total: number };
    setPagination: (updater: any) => void;
    sortConfig: SortConfig;
  }
) {
  const { searchText, searchField, serviceFilter, subServiceFilter, filters, pagination, setPagination, sortConfig } = deps;
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const params: any = {
        search: searchText,
        page: pagination.current,
        per_page: pagination.pageSize,
      };

      if (serviceFilter) params.service = serviceFilter;

      if (searchField) params.search_field = searchField;

      Object.keys(filters).forEach((key) => {
        if ((filters as any)[key]) params[key] = (filters as any)[key];
      });

      if (subServiceFilter) params.sub_service = subServiceFilter;

      if (sortConfig.field) {
        params.sort_by = sortConfig.field;
        params.sort_direction = sortConfig.order === 'ascend' ? 'asc' : 'desc';
      }

      const response = await orderService.getOrders(params);
      if (response.success) {
        const orderData = response.data.data;
        setOrders(orderData);
        setPagination((prev: any) => ({ ...prev, total: response.data.total }));
      } else {
        message.error('获取订单数据失败');
      }
    } catch (error) {
      console.error('Fetch orders error:', error);
      message.error('获取订单数据失败');
    } finally {
      setLoading(false);
    }
  }, [searchText, searchField, pagination.current, pagination.pageSize, serviceFilter, filters, subServiceFilter, sortConfig.field, sortConfig.order]);

  return { orders, setOrders, loading, fetchOrders } as const;
}
